import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { FiFileText, FiHeadphones, FiPlusCircle, FiUser } from 'react-icons/fi';
import GlobalPlayer from './GlobalPlayer';
import ServiceWakingBanner from './ServiceWakingBanner';
import './AppShell.css';

const NAV = [
  { to: '/documents', label: 'Documents', icon: FiFileText },
  { to: '/create', label: 'Create', icon: FiPlusCircle },
  { to: '/library', label: 'Library', icon: FiHeadphones },
  { to: '/account', label: 'Account', icon: FiUser },
];

// Desktop: left sidebar. Mobile: bottom tab bar. Global player floats above both.
export default function AppShell() {
  return (
    <div className="shell">
      <aside className="shell__sidebar">
        <div className="shell__brand">
          <span className="shell__logo" aria-hidden>
            🎙️
          </span>
          <span className="shell__brandName">DocuCast</span>
        </div>
        <nav className="shell__nav">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) => `shell__navItem${isActive ? ' shell__navItem--active' : ''}`}
            >
              <Icon className="shell__navIcon" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="shell__sidebarFoot muted">Turn documents into audio.</div>
      </aside>

      <main className="shell__main">
        <Outlet />
      </main>

      <nav className="shell__bottomNav">
        {NAV.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => `shell__tab${isActive ? ' shell__tab--active' : ''}`}
          >
            <Icon className="shell__tabIcon" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <GlobalPlayer />
      <ServiceWakingBanner />
    </div>
  );
}
